/* eslint-disable */
"use strict";
exports.__esModule = true;
exports.valueByPixels = void 0;
var scaleSelector_1 = require("./scaleSelector");
function resolveFunction(possibleFunction, arg) {
    if (possibleFunction && typeof possibleFunction === 'function')
        return possibleFunction(arg);
    return possibleFunction;
}
function valueByPixels(pixelsScriptable, selectScale) {
    if (selectScale === void 0) { selectScale = (0, scaleSelector_1.scaleSelector)('default'); }
    return function (_context) {
        var context = _context;
        var areaPixels = resolveFunction(pixelsScriptable, context);
        var isNegative = areaPixels < 0;
        var scale = selectScale(context);
        if (!scale) {
            return NaN;
        }
        var _a = scale, startPixes = _a._startPixel, reversePixels = _a._reversePixels, length = _a._length;
        if (isNegative) {
            var positivePixels = Math.abs(areaPixels);
            var pixels_1 = reversePixels ? startPixes + positivePixels : startPixes + length - positivePixels;
            return scale.getValueForPixel(pixels_1);
        }
        var pixels = !reversePixels ? startPixes + areaPixels : startPixes + length - areaPixels;
        return scale.getValueForPixel(pixels);
    };
}
exports.valueByPixels = valueByPixels;
